const navbar = {
  en: {
    home: "Home",
    campaings: "Arsenal",
    adversaries: "Adversaries",
    adversariesDescription:
      "They represent the tactics, techniques, and procedures (TTPs) that will be used to execute an operation.",
    agents: "Agents",
    agentsDescription:
      "They are software programs that connect to Raidstorm for instructions during the execution of an operation.",
    abilities: "Abilities",
    abilitiesDescription:
      "They are MITRE ATT&CK tactics and techniques that can be executed on agents.",
    attack: "Attack",
    attackDescription:
      "It is through the attack that the abilities defined in the adversary's construct will be executed so that the agent can obtain the requested instructions.",
    facts: "Facts",
    factsDescription:
      "Facts are information that will allow you to identify something about a particular computer, network, or environment.",
    report: "Report",
    variables: "Variables",
    rules: "Rules",
    rulesDescription:
      "Rules are a way of restricting or placing limits on an Attack plan that will be executed in an environment.",
    assessment: "Assessment"
  },
  pt: {
    home: "Home",
    campaings: "Arsenal",
    adversaries: "Adversários",
    adversariesDescription:
      "Representam as táticas, técnicas e procedimentos (TTPs) que serão usados para executar uma operação.",
    agents: "Agentes",
    agentsDescription:
      "São programas de software que se conectam ao Raidstorm para obter instruções durante a execução de uma operação.",
    abilities: "Habilidades",
    abilitiesDescription:
      "São táticas e técnicas do MITRE ATT&CK que pode ser executadas em agentes.",
    attack: "Ataque",
    attackDescription:
      "É através do ataque que serão executadas as habilidades definidas na construção do adversário para que o agente consiga obter as instruções solicitadas.",
    facts: "Facts",
    factsDescription:
      "Fatos são informações que vão permitir identificar algo sobre um determinado computador, rede ou ambiente.",
    report: "Relatório",
    variables: "Variáveis",
    rules: "Regras",
    rulesDescription:
      "As Regras são uma forma de restringir ou colocar limites em um plano de Ataque que será executado em um ambiente.",
    assessment: "Avaliações"
  },
  es: {
    home: "Home",
    campaings: "Arsenal",
    adversaries: "Adversarios",
    adversariesDescription:
      "Representan las tácticas, técnicas y procedimientos (TTP) que se utilizarán para ejecutar una operación.",
    agents: "Agentes",
    agentsDescription:
      "Son programas de software que se conectan a Raidstorm para obtener instrucciones durante la ejecución de una operación.",
    abilities: "Habilidades",
    abilitiesDescription:
      "Son tácticas y técnicas de MITRE ATT&CK que pueden ser ejecutadas en los agentes.",
    attack: "Ataque",
    attackDescription:
      "Es a través del ataque que se ejecutarán las habilidades definidas en la construcción del oponente para que el agente pueda obtener las instrucciones solicitadas.",
    facts: "Facts",
    factsDescription:
      "Los facts son información que nos permite identificar algo sobre un ordenador, una red o un entorno concretos.",
    report: "Informe",
    variables: "Variables",
    rules: "Reglas",
    rulesDescription:
      "Las Reglas son una forma de restringir o poner límites a un plan de Ataque que se ejecutará en un entorno.",
    assessment: "Evaluaciones"
  }
}

export default navbar
